import './App.css';
import { QueryClient, QueryClientProvider } from "react-query";
import { Route, BrowserRouter as Router, Routes, Navigate } from "react-router-dom";

import './assets/css/style.scss'
import './assets/css/buttons.scss'
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/js/bootstrap.bundle.min";

import LandingPage from './pages/landing.page';
import DashboardPage from './pages/dashboard.page';
import MeetingPage from './pages/meeting.page';

import { create } from "zustand";
import { persist, devtools } from "zustand/middleware";

import { Toaster } from 'react-hot-toast';
import SlotPage from './pages/slot.page';
import Venue from './pages/venue.page';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 2 * 60 * 1000, // 2 minutes
      cacheTime: 2 * 60 * 1000, // 2 minutes
    },
  },
});

export const useStore = create(
  persist(
    devtools(
      (set) => ({
        userStatus: false,
        accessToken: null,
        refreshToken: null,
        email: null,
        userType: null,
        name: null,
        location: null,
      }),
      { name: "zustand-devtools" } // optional devtools name
    ),
    {
      name: "auth-storage",
      getStorage: () => localStorage,
    }
  )
);

function App() {

  const userStatus = useStore((state) => state.userStatus);
  
  const ProtectedRoute = ({ children }) => {
    return userStatus ? children : <Navigate to="/" replace />;
  };

  return (
    <QueryClientProvider client={queryClient}>
      <Router>
        <Routes>
          <Route path="/" element={<LandingPage />} />

          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <DashboardPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/company/:id"
            element={
              <ProtectedRoute>
                <MeetingPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/company/slot/:id"
            element={
              <ProtectedRoute>
                <SlotPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/company/venue"
            element={
              <ProtectedRoute>
                <Venue />
              </ProtectedRoute>
            }
          />
        </Routes>
      </Router>
      <Toaster />
    </QueryClientProvider>
  );
}

export default App;